<template>
<!-- 打印生产单下的工单,支持批量 -->
  <div v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="获取数据。。" >
    <div style="page-break-after:always" :v-if="!showOrderItemDialog" v-for="(item,index) in printOrderMessage.workOrders" :key="index">
      <div class="title">
        <img :id="index | getIndexId('barcode')"/>
        <p align="left">{{'胚布名称:'+printOrderMessage.fabricName+'&nbsp;订单交期:'+utils.timestampToTime(printOrderMessage.consignTime,2)}}</p>
      </div>
      <table data-sort="sortDisabled" border="1" class="table main-article" cellpadding="10">
        <tbody>
          <tr>
            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" class="boldFont">机台编号</td>
            <td valign="top" colspan="1" rowspan="1" class="smallFont">{{item.machineNum}}</td>
            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" class="boldFont">车间</td>
            <td valign="top" colspan="1" rowspan="1" class="smallFont">{{item.workshop}}</td>
            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" class="boldFont">预设米数</td>
            <td valign="top" colspan="1" rowspan="1" class="smallFont">
              {{item.predictProducedLength/100}}
              <span class="miniFont"></span>
            </td>
            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" class="boldFont">落布米数</td>
            <td valign="top" colspan="1" rowspan="1" class="smallFont">
              {{item.dropClothLength/100}}
              <span class="miniFont"></span>
            </td>
          </tr>
          <tr>
            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" class="boldFont">车速</td>
            <td valign="top" colspan="1" rowspan="1" class="smallFont">{{item.speed}}<span class="miniFont">转/分钟</span></td>
            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" class="boldFont">门幅</td>
            <td valign="top" colspan="1" rowspan="1" class="smallFont">{{item.doorCount}}</td>
            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" class="boldFont">幅宽</td>
            <td valign="top" colspan="1" rowspan="1" class="smallFont">{{item.doorWidth}}</td>
            <td valign="top" colspan="1" rowspan="1"></td>
            <td valign="top" colspan="1" rowspan="1"></td>
          </tr>
          <tr>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">客户</td>
            <td width="130" valign="top" class="smallFont">{{printOrderMessage.customer}}</td>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">创建者</td>
            <td width="130" valign="top" class="smallFont">{{creator}}</td>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">工艺组织</td>
            <td width="130" valign="top" class="smallFont">{{printOrderMessage.craftOrganization}}</td>
            <td valign="top" style="word-break: break-all;" class="boldFont">密度</td>
            <td width="130" valign="top" class="smallFont">{{printOrderMessage.density}}</td>
          </tr>
          <tr>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">订单说明</td>
            <td valign="top" style="word-break: break-all;" rowspan="1" colspan="7" width="969" class="smallFont">
              {{printOrderMessage.remarks}}
            </td>
          </tr>
        </tbody>
        <tbody v-for="(item,index) in printOrderMessage.craftsheet.craftItems" :key="index">
          <tr>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">梳节</td>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">原料规格</td>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">原料批号</td>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">线圈长度</td>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">头纹</td>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">盘头个数</td>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">送纱量</td>
            <td width="130" valign="top"></td>
          </tr>
          <tr>
            <td width="130" valign="top" style="word-break: break-all;" rowspan="3" colspan="1">{{item.combSection}}</td>
            <td width="130" valign="top" class="smallFont">{{item.materialBatch}}</td>
            <td width="130" valign="top" class="smallFont">{{item.materialStandard}}</td>
            <td width="130" valign="top" class="smallFont">{{item.coilLength}}<span class="miniFont">mm/腊克</span></td>
            <td width="130" valign="top" class="smallFont">{{item.headVeins}}<span class="miniFont">根</span></td>
            <td width="130" valign="top" class="smallFont">{{item.panHeadNum}}</td>
            <td width="130" valign="top" class="smallFont">{{item.sendYarnFeed}}</td>
            <td width="130" valign="top"></td>
          </tr>
          <tr>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">垫纱记录</td>
            <td valign="top" rowspan="1" colspan="6" style="word-break: break-all;" class="smallFont">
              {{item.padYarnRecord}}
            </td>
          </tr>
          <tr>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">穿纱方式</td>
            <td valign="top" rowspan="1" colspan="6" class="smallFont">
              {{item.crossYarnWay}}
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr>
            <td width="130" valign="top" style="word-break: break-all;" class="boldFont">工艺说明</td>
            <td valign="top" style="word-break: break-all;" rowspan="1" colspan="7" width="969" class="smallFont">
              {{printOrderMessage.craftsheet.craftRemarks}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <el-dialog title="选择需要打印的工单" :visible.sync="showOrderItemDialog" @close="closeDialog" fullscreen>
      <!-- <p style="margin:0">注意：如页面不可点击，请将新弹出的打印页面中的打印弹框取消</p> -->
      <el-table ref="OrderItemList" :data="printOrderResponse.workOrders" highlight-current-row  @selection-change="selectOrder">
        <el-table-column type="selection"></el-table-column>
        <el-table-column property="number" label="工单编号" width="180"></el-table-column>
        <el-table-column property="machineNum" label="机台编号" width="120"></el-table-column>
        <el-table-column property="workshop" label="生产车间"></el-table-column>
      </el-table>
      <span slot="footer">
          <el-button type="primary" @click="printOrders" :disabled="btnDisabled">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import jsbarcode from 'jsbarcode'
import * as api from '@/api/factory/product/orderList/print'
export default {
  name: 'ProductOrderPrint',
  data() {
    return {
      printOrderResponse: {},
      selectOrders: [],
      showOrderItemDialog: false,
      printOrderMessage: {},
      fullscreenLoading: true,
      btnDisabled: true,
      creator: ''
    }
  },
  methods: {
    // 获取生产单的数据
    fetchData() {
      var params = { productOrderId: this.$route.params.id }
      return api.fetchData(params).then((res) => {
        // 对疏节进行排序 GB1
        res.data.craftsheet.craftItems = this._.sortBy(res.data.craftsheet.craftItems, item => {
          return item.combSection
        })
        this.getCreatorInfo(res.data.creatorId)
        return res.data
      })
    },
    // 因为生产单数据中工单是没有对应的机台信息的只有机台ID，
    // 所以拿机台ID再去查出机台信息，再对原数据进行拼接。
    getMachineInfo(orderResponse) {
      const machineIDArr = []
      orderResponse.workOrders.forEach(obj => {
        machineIDArr.push(obj.machineId)
      })
      if (machineIDArr.length === 0) {
        this.fullscreenLoading = false
        this.$confirm('该生产单下无工单', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          window.close()
        })
        return
      }
      api.getEquipData({ machineIds: machineIDArr }).then(res => {
        // TODO 后端目前是按顺序返回的，要考虑不按顺序返回的情况
        const machineInfo = res.data
        orderResponse.workOrders.forEach((obj, index) => {
          obj.machineNum = machineInfo[index].number
          obj.workshop = machineInfo[index].workshop

          this.printOrderResponse = orderResponse
          this.fullscreenLoading = false
          this.showOrderItemDialog = true
        })
      })
    },
    // 获取生产单创建者的信息
    getCreatorInfo(workerId) {
      api.getCreatorInfo(workerId).then(res => {
        this.creator = res.data.username
      })
    },
    // 选择打印的工单
    selectOrder(selection) {
      this.selectOrders = selection
    },
    // 点击打印按钮
    printOrders() {
      if (this._.isEmpty(this.selectOrders)) {
        this.$message.error('没有选择工单！')
        return
      }
      var printMessage = this._.cloneDeep(this.printOrderResponse)
      printMessage.workOrders = this.selectOrders
      this.printOrderMessage = printMessage
      this.showOrderItemDialog = false
      // 这里延迟的目的是为了条码，不然条码可能出不了。
      setTimeout(() => {
        this.printOrderMessage.workOrders.forEach((item, index) => {
          jsbarcode('#barcode' + index, item.number, { displayValue: true })
        })
      }, 500)
      setTimeout(() => {
        window.print()
      }, 500)
    },
    closeDialog() {
      if (this._.isEmpty(this.selectOrders) || this._.isEmpty(this.printOrderMessage)) {
        window.close()
      }
    }
  },
  filters: {
    getIndexId(index, id) {
      return id + index
    }
  },
  created() {
  },
  mounted() {
    this.fetchData().then(res => {
      this.getMachineInfo(res)
    })
    // 在打印之后，再次显示工单选择弹框
    window.onafterprint = () => {
      this.showOrderItemDialog = true
    }
    // 在打印前清空选择数据
    window.onbeforeprint = () => {
      this.selectOrders = []
      this.printOrderMessage = {}
      this.$refs.OrderItemList.clearSelection()
    }
  },
  beforeDestroy() {
    // window.sessionStorage.removeItem('printOrder')
  },
  watch: {
    selectOrders: function(val) {
      // 如果没有选择工单，则打印按钮为灰色
      if (this.utils.isEmpty(val)) {
        this.btnDisabled = true
      } else {
        this.btnDisabled = false
      }
    }
  }
}
</script>

<style scoped media="print">
/* @page {
      size: auto;
      margin: 0;
} */
span {
  font-size: 12px;
  transform: scaleX(0.8) scaleY(0.8)
}
.smallFont {
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
}
.boldFont {
  font-weight: 600;
}
.title {
  display: flex;
  align-items: flex-start;
 }
td {
  padding: 3px;
}
img {
  left: 0;
  width: 150px;
  height: 60px;
}
.main-article {
  text-align: center;
}
.table {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-collapse: collapse;
  border-spacing: 0;
}
</style>
